import { AddQueryParamsToUrlArgs } from '../models/Urls';

export const addQueryParamsToUrl = ({ url: _url, params }: AddQueryParamsToUrlArgs): string => {
  const url = new URL(_url);
  Object.entries(params || {}).forEach(([key, value]) => url.searchParams.append(key, value.toString()));
  return url.href;
};
